var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2755 6.862C5.45128 7.03778 5.68072 7.11847 5.96383 7.10408C6.24772 7.0893 6.45714 6.98916 6.59208 6.80366L9.6575 2.5325L5.36358 5.57516C5.17069 5.70505 5.062 5.9063 5.0375 6.17891C5.01339 6.45153 5.09292 6.67941 5.27608 6.86258M1.975 9.08333C1.86611 9.08333 1.76656 9.05591 1.67633 9.00108C1.58611 8.94586 1.50989 8.8708 1.44767 8.77591C1.21744 8.37886 1.04361 7.95905 0.926167 7.5165C0.808722 7.07394 0.75 6.624 0.75 6.16666C0.75 5.44216 0.888056 4.76044 1.16417 4.1215C1.44028 3.48255 1.81497 2.92703 2.28825 2.45491C2.76153 1.9828 3.31706 1.60811 3.95483 1.33083C4.59261 1.05355 5.27433 0.915497 6 0.916664C6.72256 0.916664 7.40019 1.05239 8.03292 1.32383C8.66564 1.59527 9.22019 1.96511 9.69658 2.43333C10.173 2.90155 10.5498 3.4493 10.8271 4.07658C11.1044 4.70386 11.2444 5.37897 11.2471 6.10191C11.249 6.58414 11.1919 7.05275 11.0756 7.50775C10.9593 7.96275 10.7837 8.40064 10.5488 8.82141C10.4944 8.9163 10.4201 8.98378 10.326 9.02383C10.2319 9.06389 10.1304 9.08391 10.0215 9.08391L1.975 9.08333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.ee1f05f471da0b59a5a39419a93880e7.svg";
export { ForwardRef as ReactComponent };